import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import * as routes from './routes';
import './styles/index.less';
import useDirection from './hooks/useDirection';
import MainLayout from './layout/MainLayout';
import { useAntdLocale } from '~/hooks/useAntdLocale';
import { initMomentLocales, languagesConfig } from '~/utils/i18n';
initMomentLocales();

const { defaultRoutes, specialRoutes } = routes;

const removePreloader = (): void => {
  const ele = document.getElementById('ipl-progress-indicator');
  if (ele) {
    // fade out
    ele.classList.add('available');
    setTimeout(() => {
      // remove from DOM
      ele.outerHTML = '';
    }, 500);
  }
};

const App = (): JSX.Element => {
  const { i18n, t } = useTranslation();
  const language = i18n.language;
  moment.locale(languagesConfig[language].momentLocale);

  useEffect(() => {
    removePreloader();
  }, []);

  const antdLocale = useAntdLocale(language);

  const validateMessages: Record<string, any> = {
    required: t('required'),
    string: {
      min: (name: string, min: number) => {
        return t('inputStringMin', { min });
      },
    },
  };

  const [direction, setDirection] = useDirection();
  useEffect(() => {
    if (languagesConfig[language].isRTL) {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }
  }, [language, setDirection]);

  return (
    <ConfigProvider form={{ validateMessages }} locale={antdLocale.locale} direction={direction}>
      <Layout className="App">
        <Switch>
          {specialRoutes.map((route) => {
            const { path, exact, component } = route;
            return <Route key={path} path={path} exact={exact} component={component} />;
          })}
          <Route>
            <MainLayout>
              {defaultRoutes.map((route) => {
                const { path, exact, component } = route;
                return <Route key={path} path={path} exact={exact} component={component} />;
              })}
            </MainLayout>
          </Route>
        </Switch>
      </Layout>
    </ConfigProvider>
  );
};

export default App;
